var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "token-branded:sol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4572 4.47049C11.3876 4.53347 11.2977 4.56918 11.2039 4.57104H2.30108C1.98553 4.57104 1.82553 4.20993 2.04442 3.99882L3.50608 2.58882C3.57418 2.52306 3.66476 2.48571 3.75942 2.48438H12.6966C13.0161 2.48438 13.1728 2.84882 12.9505 3.06104L11.4572 4.47049Z",
    fill: "url(#paint0_linear_2005_15518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4572 11.4187C11.3877 11.4814 11.2974 11.516 11.2039 11.516H2.30108C1.98553 11.516 1.82553 11.1582 2.04442 10.9465L3.50608 9.53317C3.57447 9.46835 3.66519 9.43234 3.75942 9.43262H12.6966C13.0161 9.43262 13.1728 9.79373 12.9505 10.0054L11.4572 11.4187Z",
    fill: "url(#paint1_linear_2005_15518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.4572 6.05718C11.3877 5.99452 11.2974 5.95988 11.2039 5.95996H2.30108C1.98553 5.95996 1.82553 6.31774 2.04442 6.52941L3.50608 7.94274C3.57563 8.00572 3.66561 8.04143 3.75942 8.04329H12.6966C13.0161 8.04329 13.1728 7.68218 12.9505 7.47052L11.4572 6.05718Z",
    fill: "url(#paint2_linear_2005_15518)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2005_15518",
    x1: 1.94386,
    y1: 9.66715,
    x2: 13.3205,
    y2: 9.21604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#599DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47F8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2005_15518",
    x1: 1.94386,
    y1: 10.071,
    x2: 13.2539,
    y2: 9.69595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C44FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73B0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2005_15518",
    x1: 2.58275,
    y1: 7.00163,
    x2: 12.6239,
    y2: 7.00163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#778CBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DCDC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.f4df815477471348a846895cf3a9159b.svg";
export { ForwardRef as ReactComponent };